export const NotificationConstants = {
  ITEMS_PER_PAGE: 25,
  INITIAL_PAGE_SIZE: 10, // Needs to be the same as that in userData.py
};
